import React from 'react';
import { Icon } from '../../icons';

interface AlertProps {
  type: 'error' | 'warning' | 'info' | 'success';
  message: string;
  onClose?: () => void;
  title?: string;
  requestId?: string | null;
}

export const Alert: React.FC<AlertProps> = ({ type, message, onClose, title, requestId }) => {
  const baseClasses = 'p-4 rounded-md border-l-4';
  
  const typeClasses = {
    error: 'bg-red-50 border-red-400 text-red-700',
    warning: 'bg-yellow-50 border-yellow-400 text-yellow-700',
    info: 'bg-blue-50 border-blue-400 text-blue-700',
    success: 'bg-green-50 border-green-400 text-green-700',
  };


  const iconTokens = {
    error: 'error',
    warning: 'info', // puedes crear un token 'warning' si lo agregas al sistema
    info: 'info',
    success: 'check',
  } as const;

  const iconClasses = {
    error: 'text-red-400',
    warning: 'text-yellow-400',
    info: 'text-blue-400',
    success: 'text-green-400',
  };

  return (
    <div className={`${baseClasses} ${typeClasses[type]}`}>
      <div className="flex">
        <div className="flex-shrink-0">
          <Icon
            name={iconTokens[type]}
            size={20}
            className={`h-5 w-5 ${iconClasses[type]}`}
            title={type}
          />
        </div>
        <div className="flex-1 ml-3">
          {title && (
            <h3 className="text-sm font-medium">{title}</h3>
          )}
          <p className={`text-sm ${title ? 'mt-1' : ''}`}>{message}</p>
          {typeof requestId !== 'undefined' && requestId !== null && (
            <p className="mt-1 text-xs text-gray-500">Código de seguimiento: {requestId}</p>
          )}
        </div>
        {onClose && (
          <div className="pl-3 ml-auto">
            <button
              type="button"
              className={`inline-flex rounded-md p-1.5 hover:bg-gray-100 focus:outline-none focus:ring-2 cursor-pointer focus:ring-offset-2 ${iconClasses[type]}`}
              onClick={onClose}
            >
              <svg className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
